// src/pages/RadiantIsleRH.js
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function FishingShop() {
  React.useEffect(() => {
    document.title = "Fishing Shop | Pokémon Radiance";
  }, []);

  return <GameMap config={mapConfigs.fishingShop} />;
}
